import { isStaffEmail, isStaffUser } from 'utils/user'

const userOf = row => row?.user || row

export const isHiddenStaff = (row, currentUserId) => {
  const user = userOf(row)
  if (currentUserId != null && user?.id != null && String(user.id) === String(currentUserId)) return false
  return isStaffUser(user) || isStaffEmail(user?.email)
}

export const visibleAccessRows = (rows, currentUserId) =>
  (Array.isArray(rows) ? rows : []).filter(row => !isHiddenStaff(row, currentUserId))

export const countVisibleUsers = (rows, currentUserId) => visibleAccessRows(rows, currentUserId).length

const WEEK_MS = 7 * 24 * 60 * 60 * 1000

export const countActiveThisWeek = (rows, now = Date.now()) =>
  (Array.isArray(rows) ? rows : []).filter(row => {
    const seen = userOf(row)?.lastActivityAt
    return seen && new Date(seen).getTime() >= now - WEEK_MS
  }).length

export const peopleSummary = (total, active) => {
  const people = `${total.toLocaleString('en-GB')} ${total === 1 ? 'person' : 'people'}`
  return `${people}, ${active.toLocaleString('en-GB')} active this week`
}
